import { IDocumentationState } from "processEditor/model/State";
import { IAction } from "../model/IAction";

export const UPDATE_DOCUMENTATION_PANEL = "UPDATE_DOCUMENTATION_PANEL";
export function updateDocumentationPanel(documentation: IDocumentationState): UpdateDocumentationPanelAction {
    return {
        type: UPDATE_DOCUMENTATION_PANEL,
        documentation
    };
}

export interface UpdateDocumentationPanelAction extends IAction {
    documentation: IDocumentationState;
}
